import config from 'config'
import { METHODS } from 'constants.js'
import { localeInstance } from 'locale'
import { enqueueSnackbar } from 'Notifications/actions'
import type { Action } from 'redux'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import type { NetworkError } from 'utils'
import { getErrorTranslationKey } from 'utils'
import { fetchAction } from 'utils'

import { postBugReportError, postBugReportSuccess } from './actions'
import { POST_BUG_REPORT } from './constants'

interface BugReportRequest extends Action {
  storeId: number
}

const postBugReport = createLogic<State, BugReportRequest>({
  type: POST_BUG_REPORT,
  latest: true,

  async process({ action }, dispatch, done) {
    try {
      await fetchAction(config.api.bugReport, action.payload, METHODS.POST)

      dispatch(postBugReportSuccess())
    } catch (error) {
      const errorCode = (error as NetworkError)?.response?.status || null

      dispatch(postBugReportError({ errorCode }))
      dispatch(
        enqueueSnackbar({
          message: localeInstance.t(`alert.${getErrorTranslationKey(errorCode)}`),
        }),
      )
    }

    done()
  },
})

export default [postBugReport]
